module.exports = __webpack_public_path__ + "img/oldhouse.d95bd90c.jpg";